import React, { memo } from 'react';

import { defaultSize, sizePropsTypes } from './icons.constants';

const OverflowIcon = ({ size = defaultSize, ...props }) => (
  <svg
    fill="none"
    height={size}
    viewBox="0 0 24 24"
    width={size}
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M4 4H20V20H4V4Z"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="2"
    />
    <path
      d="M9 9H23M23 9L20 6M23 9L20 12"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="2"
    />
  </svg>
);

OverflowIcon.propTypes = {
  ...sizePropsTypes,
};

export default memo(OverflowIcon);
